import React from 'react';
import {Trans} from 'react-i18next';
import {history} from '../../../../utils/redux/store';

export default function ContactSalesCard() {
  return (
    <div className="portlet-body">
      <div className="kt-portlet kt-portlet--solid-gray p-4">
        <h6>
          <Trans i18nKey="p.s.recommendation.customize.customized.ui.title">
            Customized UI
          </Trans>
        </h6>
        <div>
          <p>
            <Trans i18nKey="p.s.recommendation.customize.customized.ui.desc">
              If you’re looking for customized app pages to meet your business
              needs, please contact our sales team for more information and a
              tailored quote.
            </Trans>
          </p>
        </div>
        <div className="text-center">
          <button
            className="btn btn-brand btn-elevate"
            onClick={() => history.push('/contactus/add-request')}
          >
            <Trans i18nKey="p.contactus.title">Contact Us</Trans>
          </button>
        </div>
      </div>
    </div>
  );
}
